/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModificarGradoInteraccionPrincipioActivoDto } from '../../models/modificar-grado-interaccion-principio-activo-dto';

export interface DoctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo$Params {
  interaccionUuid: string;
      body: ModificarGradoInteraccionPrincipioActivoDto
}

export function doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo(http: HttpClient, rootUrl: string, params: DoctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo$Params, context?: HttpContext): Observable<StrictHttpResponse<ModificarGradoInteraccionPrincipioActivoDto>> {
  const rb = new RequestBuilder(rootUrl, doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo.PATH, 'patch');
  if (params) {
    rb.path('interaccionUuid', params.interaccionUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModificarGradoInteraccionPrincipioActivoDto>;
    })
  );
}

doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo.PATH = '/api/principios-activos/interacciones/{interaccionUuid}';
